export default "__VITE_ASSET__DNmcaBue__"